import React, { createContext, useContext, ReactNode } from 'react';
import { useCookieConsent, CookieConsentState } from '../../hooks/useCookieConsent';

interface CookieConsentContextType {
  consentState: CookieConsentState;
  acceptAll: () => void;
  rejectAll: () => void;
  acceptAnalytics: () => void;
  hasMadeChoice: boolean;
}

const CookieConsentContext = createContext<CookieConsentContextType | undefined>(undefined);

interface CookieConsentProviderProps {
  children: ReactNode;
}

export const CookieConsentProvider: React.FC<CookieConsentProviderProps> = ({ children }) => {
  const cookieConsent = useCookieConsent();

  return (
    <CookieConsentContext.Provider value={cookieConsent}>
      {children}
    </CookieConsentContext.Provider>
  );
};

export const useCookieConsentContext = () => {
  const context = useContext(CookieConsentContext);
  if (context === undefined) {
    throw new Error('useCookieConsentContext must be used within a CookieConsentProvider');
  }
  return context;
}; 